import { atom, selectorFamily } from "recoil";
import ProfessionalService from "src/services/agenda/professionals";

export const imageProfessionalState = atom({
    key: 'imageProfessional',
    default: null
});


export const showMoldalImageProfessionalState = atom({
    key: 'showMoldalImageProfessional',
    default: false
});

export const professionalDetailFetchState = selectorFamily({
    key: 'professionalDetailFetch',
    get: ptdRut => async () => {
        const { data } = await ProfessionalService.getDetailProfessional(ptdRut);

        return data;
    } 
});

export const professionalDetailState = atom({
    key: 'professionalDetail',
    default: null
})